export default {
  module: "Module",
  submit: "Submit",
  configurationWasSuccessfullyUpdated: "Configuration was successfully updated",
  finalReleaser: "Final releaser",
  firstReleaseSuggestion: "Release suggestion 1",
  secondReleaseSuggestionN: "Release suggestion 2",
  userReleaseSuggestion: "User release suggestion",
};
